import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _8kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"8k_plus"}/>
}
